import styled from "styled-components";
import loginImage from "../../assets/images/loginImage.svg";

export const SetNewPasswordWrapper = styled("div")(() => {
  return {
    padding: 0,
    background: "var(--color-background)",
    minHeight: "100vh",
    "& h1": {
      fontWeight: 700,
      color: "#ddf9d9",
      marginBlockStart: "0",
    },
    "& h2": {
      fontWeight: 500,
      color: "#ddf9d9",
      marginBlockStart: "0",
      width: "90%",
    },

    "& .main-area": {
      gap: 0,
      height: "100vh",
      "@media screen and (max-width: 768px)": {
        padding: "calc(var(--cardPadding))",
        flexDirection: "column",
      },
      "@media screen and (min-width: 769px) and (max-width: 1024px)": {
        alignItems: "stretch",
        flexDirection: "row",
      },
    },
    "& .auth-img": {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      flex: 1,
      padding: "calc(var(--cardPadding) * 3)",
      minHeight: "300px",
      backgroundImage: `url(${loginImage})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      overflow: "hidden",
      "@media screen and (max-width: 768px)": {
        display: "none",
      },
      "@media screen and (min-width: 769px) and (max-width: 1024px)": {
        padding: "calc(var(--cardPadding) * 2)",
      },
      "& svg": {
        width: "100%",
        height: "auto",
      },
    },
    "& .auth-form": {
      flex: 1,
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap))",
      padding: "calc(var(--cardPadding) * 2)",
      justifyContent: "center",
      "& legend": {
        fontFamily: "Poppins",
        fontWeight: 700,
        fontSize: "28px",
        lineHeight: 1.3,
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingInline: 0,
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "20px",
        color: "var(--color-text)",
        lineHeight: "3rem",
      },
      "&  input": {
        fontSize: "20px",
        fontWeight: "400",
        padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) /2)",
        outline: "none",
        border: "1px solid var(--color-primary-hover)",
        backgroundColor: "var(--color-button-secondary)",
        borderRadius: ".45rem",
      },
      "& button": {
        padding: "0.7rem 0.8rem",
        borderRadius: "0.45rem",
      },
      "@media screen and (max-width: 768px)": {
        padding: 0,
        "& legend": {
          fontSize: "20px",
          textAlign: "center",
        },
        "& label, & input": {
          fontSize: "16px",
        },
      },
    },
    "& .logo-box-area": {
      maxWidth: "100%",
      marginBlockEnd: "calc(var(--cardPadding)/2)",
      "& svg": {
        width: "100%",
        height: "auto",
      },
    },
    " .logo-box-black": {
      display: "none",
      maxWidth: "350px",
      marginBlockEnd: "calc(var(--cardPadding))",
      "@media screen and (max-width: 425px)": {
        display: "block",
        maxWidth: "200px",
        marginBlockEnd: "calc(var(--cardPadding)/2)",
        "& svg": {
          width: "100%",
          height: "auto",
        },
      },
      "@media screen and (max-width: 768px)": {
        display: "block",
        maxWidth: "200px",
        marginBlockEnd: "calc(var(--cardPadding)/2)",
        "& svg": {
          width: "100%",
          height: "auto",
        },
      },
    },
  };
});
